import { render, staticRenderFns } from "./HrdcJob.vue?vue&type=template&id=6c08f4f7&scoped=true&"
import script from "./HrdcJob.vue?vue&type=script&lang=js&"
export * from "./HrdcJob.vue?vue&type=script&lang=js&"
import style0 from "./HrdcJob.vue?vue&type=style&index=0&id=6c08f4f7&scoped=true&lang=css&"
import style1 from "./HrdcJob.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08f4f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VDataTable,VIcon,VSpacer,VTooltip})
